import React from "react";

class InfiniteScrollFooter extends React.Component {
  render() {
    return <div>I'm the footer</div>;
  }
}

InfiniteScrollFooter.propTypes = {};
